import DemandsDb from "@/firebase/demands-db";
import ChatsDb   from "@/firebase/chat-db";
import firestore from "@/firebase/async-firestore";
import axios     from "axios";
import moment    from "moment";

export default {
    getDemands    : async ({commit}, withHidden = false) => {
        const demandsDb = new DemandsDb();

        commit("setDemandsLoading", true);

        try {
            const demands = await demandsDb.getDemandsWithDateDescendant(withHidden);
            // Sort the demands based on the last update timestamp
            demands.sort((a, b) => new Date(b.updateTimestamp) - new Date(a.updateTimestamp));

            commit("setDemands", demands);
            commit("setDemandsLoading", false);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
            commit("setDemandsLoading", false);
        }
    },
    getDemand     : async (store, demandID) => {
        const demandsDb = new DemandsDb();

        try {
            return await demandsDb.read(demandID);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
        }

        return false;
    },
    createDemand  : async ({rootState, commit}, demand) => {
        const user     = {...rootState.authentication.user};
        const demandDb = new DemandsDb();

        demand.author                = user;
        demand.authorLastInteraction = moment().unix();

        commit("setDemandsFormSaving", true);
        try {
            const newDemand = await demandDb.create(demand);
            commit("appendDemand", newDemand);

            const chatDb               = new ChatsDb(newDemand.id);
            const initialDemandMessage = {
                type   : "initial",
                author : user,
                message: "Ready to accept messages"
            };
            await chatDb.create(initialDemandMessage);

            await axios.post(
                "https://us-central1-rr-production-cbc1f.cloudfunctions.net/notifyAllMembers",
                {
                    "demand": newDemand.id
                }
            );

            commit("setDemandsFormSaving", false);

            return newDemand;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
            commit("setDemandsFormSaving", false);
        }

        return false;
    },
    updateDemand  : async ({rootState, commit}, demand) => {
        const user     = {...rootState.authentication.user};
        const demandDb = new DemandsDb();

        if (user.role !== "administrator") {
            if (demand.author.id !== user.id) {
                return false;
            }
        }

        commit("setDemandsFormSaving", true);

        try {
            await demandDb.update(demand);
            commit("setDemandsFormSaving", false);
            return true;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
            commit("setDemandsFormSaving", false);
        }

        return false;
    },
    deleteDemand  : async ({state, commit}, demandID) => {
        const demandsDb = new DemandsDb();
        const chatDb    = new ChatsDb(demandID);

        const chatMessages      = await chatDb.readAll();
        const [list, chuckSize] = [chatMessages, 400];
        const chunks            = [...Array(Math.ceil(list.length / chuckSize))].map(() => list.splice(0, chuckSize));

        /* eslint-disable */
        for (const chunk of chunks) {
            const batch = (await firestore()).batch();

            for (const message of chunk) {
                const ref = await chatDb.delete(message.id);
                batch.delete(ref);
            }

            await batch.commit();
        }
        /* eslint-enable */

        try {
            await demandsDb.delete(demandID);
            const demandIdx = state.demands.map(item => item.id).indexOf(demandID);

            commit("deleteDemandByIndex", demandIdx);
            return true;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message);
        }

        return false;
    },
    hideOldDemands: async ({commit}) => {
        const demandsDb = new DemandsDb();

        commit("setDemandsLoading", true);
        await demandsDb.hideOldDemands();
        commit("setDemandsLoading", false);
    }
};
